import { useId } from 'react';
import { useT } from '../../i18n';
import { useToast } from '../../chrome/Toast';
import { useTrack } from '../../lib/analytics';
import { Button } from '../Button/Button';
import './buddy.css';

export interface BuddyCardProps {
  /** The visitor's own affiliate link (AffiliateWP, issued by the API). */
  link: string;
}

/**
 * "Be somebody's Buddy" — the referral hook on every ending (S6-stop, S8, S12, S15).
 * No reward figure (decision 9): the reward is whatever AffiliateWP pays.
 * Share sheet where there is one; otherwise copy the link; otherwise show it.
 */
export function BuddyCard({ link }: BuddyCardProps) {
  const t = useT();
  const toast = useToast();
  const track = useTrack();
  const titleId = useId();

  async function share() {
    track('buddy_share');
    const data = { title: t('common.buddy.shareTitle'), text: t('common.buddy.shareText'), url: link };
    if (navigator.share) {
      try {
        await navigator.share(data);
        return;
      } catch {
        /* dismissed or unsupported: fall through to copy */
      }
    }
    try {
      await navigator.clipboard.writeText(link);
      toast(t('common.buddy.copied'));
    } catch {
      toast(link);
    }
  }

  return (
    <section className="buddy" aria-labelledby={titleId}>
      <h3 id={titleId}>{t('common.buddy.title')}</h3>
      <p>{t('common.buddy.body')}</p>
      <Button variant="gold" onClick={share}>
        {t('common.buddy.share')}
      </Button>
    </section>
  );
}
